// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yandex-reviews-block__title[data-v-4520511d]{margin-bottom:20px}.yandex-reviews-block__iframe iframe[data-v-4520511d]{width:100%;height:1300px;border:1px solid #e6e6e6;border-radius:8px;box-sizing:border-box}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
